import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { selectedActuatorI } from '../types/actuators';
import { ActuatorStateI } from '../types/app';

const getInitalActuatorsState = (): selectedActuatorI => ({
    actuator: {
        tech: '',
        id: undefined,
        type: '',
        applianceType: '',
        name: '',
        refImg: '',
        icon: '',
        connectedAppliances: [],
        connectedAppliancesByChannel: [],
        state: '',
        dinrail: false,
        x: undefined,
        y: undefined,
        numberOfChannels: 1,
        maximumApplianceConnections: 1
    }
});

const initialState: selectedActuatorI = getInitalActuatorsState();

const actuatorsSlice = createSlice({
    name: 'actuators',
    initialState,
    reducers: {
        setSelectedActuator: (state, action: PayloadAction<ActuatorStateI>) => {
            state.actuator = action.payload;
        }
    }
});

export const {
    setSelectedActuator
} = actuatorsSlice.actions;
export default actuatorsSlice.reducer;